import { defaultPm2PrintChunkClassName, avoidBreakInside } from '@provider/print';
import { generateJsxKey } from '@utils/ast';
import { Card } from './molecules/card/card.js';
import { heading, grid } from './printer.to-paper.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const printCardsComponentPaper = (node, context) => {
  return [{
    containerClassName: defaultPm2PrintChunkClassName,
    content: /*#__PURE__*/jsxs("div", {
      children: [/*#__PURE__*/jsx("h2", {
        className: heading,
        children: node.meta.title
      }), /*#__PURE__*/jsx("ul", {
        className: grid,
        children: node.cards.map((card, index) => /*#__PURE__*/jsx("li", {
          ...avoidBreakInside(),
          children: /*#__PURE__*/jsx(Card, {
            card: card,
            layout: "grid"
          })
        }, index))
      }, generateJsxKey(context))]
    })
  }];
};
const cardsComponentPaperPrinters = {
  "cards-component": printCardsComponentPaper
};

export { cardsComponentPaperPrinters };
//# sourceMappingURL=printer.to-paper.js.map
